// @owners { team: patients-team }
import { type QueryClient, matchQuery } from '@tanstack/react-query';
import { nextAvailableDatesQueryKeys } from '~shared/features/next-available-date/queries/nextAvailableDatesQueryKeys';

const nextAvailableDatesQueryFilter = { queryKey: nextAvailableDatesQueryKeys.all };

/**
 * React Query's {@link QueryCache.subscribe} fires for **every** query change. NAD hooks use
 * `useSyncExternalStore` over the cache; without filtering, cart/shipment queries (e.g. from checkout)
 * schedule updates on unrelated trees (e.g. homescreen `PrescriptionInfo` via `useBackorderedMedication`)
 * during checkout render and trigger "Cannot update a component while rendering a different component".
 */
export const subscribeNextAvailableDatesQueryCache = (
  queryClient: QueryClient,
  onStoreChange: () => void,
): (() => void) => {
  return queryClient.getQueryCache().subscribe((event) => {
    if (matchQuery(nextAvailableDatesQueryFilter, event.query)) {
      onStoreChange();
    }
  });
};
